import requestHandler from 'shared/utils/request-handler';
import { IFriendResponse } from './friend.dto';

const BASE_URL = '/api/v1/Friend';

export const GETFriends = async () => {
	return requestHandler.call<IFriendResponse>({ url: `${BASE_URL}`, method: 'get' }).then(res => res.data);
};
